import { render, staticRenderFns } from "./contactList.vue?vue&type=template&id=42a5c22c&scoped=true"
import script from "./contactList.vue?vue&type=script&lang=js"
export * from "./contactList.vue?vue&type=script&lang=js"
import style0 from "./contactList.vue?vue&type=style&index=0&id=42a5c22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a5c22c",
  null
  
)

export default component.exports